import * as React from 'react';
import { Typography, Box, List, ListItem, ListItemText, Divider, Link } from '@mui/material';
import ChevronRight from '@mui/icons-material/ChevronRight';
import appSettings from '../../appSettings';
import '../../common/theme/CommonStyles.scss';
import './QuickLinks.scss';
import { useFormSubmit } from '../../utils/useFormSubmit';
import constants from '../../constants';


const QuickLinks = ({quickLinkData, showReportingCommonModal, natPayEncodedMessage}) => {
  const numOfLinks = quickLinkData.length;
  const playIcon = require('../../img/play-icon.png');
  const { formRef, inputRef, handleSubmit } = useFormSubmit(natPayEncodedMessage);

  return (
    <Box className='quickLinks'>
      <Box className='quickLinksCard'>
        <Typography className='quickLinks-title'>
          Quick links
        </Typography>
        <List className='quick-links-text'>
          {
            quickLinkData &&
            <>
              {quickLinkData.map((elem, index) => (
                (elem.display) && <div key={index}>
                {elem.display.toLowerCase() === constants.policyDocumentsPortal ? (
                  <form name='input' action={`${appSettings.AGENT_REDIRECT_URL}`} method='post' target='_blank' ref={formRef}>
                    <Link href="#"  onClick={handleSubmit}>
                        <ListItem>
                            <input  type="hidden" name="login" ref={inputRef}/>
                            <ListItemText primary={elem.display} />
                            <ChevronRight className='li-icon' />                       
                        </ListItem>
                    </Link>
                    </form>
                ) : (elem.display.toLowerCase() === constants.reports ? (
                  <Link onClick={showReportingCommonModal}>
                    <ListItem>
                      <ListItemText primary={elem.display} className="reporting-link" />
                      <ChevronRight className='li-icon' />
                    </ListItem>
                  </Link>
                  ) : (
                  <Link href={elem.url} target="_blank">
                    <ListItem>
                      {elem?.display.toLowerCase() === 'amsuite+ tutorial' &&
                        <>
                          <img className='play-icon' src={playIcon} alt='play' />
                        </>
                      }
                      <ListItemText primary={elem.display} className={elem?.display.toLowerCase() === 'amsuite+ tutorial' ? 'amsuite-plus-link' : ''} />
                      <ChevronRight className='li-icon' />
                    </ListItem>
                  </Link>
                  )
                )}
                {(index < numOfLinks - 1) && <Divider />}
              </div>)
              )}
            </>
          }
        </List>
      </Box>
    </Box>
  );
}

export default QuickLinks;
